//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlineSpinner from '../common/InlineSpinner.vue';

export default {
  name: 'AddMember',
  data() {
    return {
      error: null,
      success: false,
      loading: false,
      typeOptions: {
        0: 'Choose Member Type',
        1: 'Athlete',
        2: 'Trainer',
        3: 'Coach',
      },
      teamDataVisibleOptions: {
        0: 'No',
        1: 'Yes',
      },
      rowTemplate: {
        email_address: null,
        first_name: null,
        last_name: null,
        member_type_id: 0,
        trainer_email: null,
        password: null,
        team_name: null,
        team_data_visible: 0,
      },
      newMembers: [],
    };
  },
  created() {
    this.newMembers.push(this.rowTemplate);
  },
  methods: {
    async add_members() {
      this.loading = true;
      try {
        let promises = [];
        this.newMembers.forEach((member) => {
          if (member.member_type_id === '2') {
            promises.push(this.$container.dao.addAndConfirmMember(member));
          }
        });
        await Promise.all(promises);

        promises = [];
        this.newMembers.forEach((member) => {
          if (member.member_type_id !== '2') {
            promises.push(this.$container.dao.addAndConfirmMember(member));
          }
        });
        await Promise.all(promises);

        this.success = true;
      } catch (e) {
        this.error = e.message;
      } finally {
        this.loading = false;
      }
    },
    add_form_row() {
      const newRow = Object.assign({}, this.rowTemplate);
      const lastRow = this.newMembers[this.newMembers.length - 1];
      newRow.trainer_email = lastRow.trainer_email;
      newRow.password = lastRow.password;
      newRow.member_type_id = lastRow.member_type_id;
      this.newMembers.push(newRow);
    },
  },
  components: {
    InlineSpinner,
  },
};
